import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery } from 'src/services/apiClient';

export const APP_ROLES_API_REDUCER_PATH = 'appRolesApi';

export const appRolesApi = createApi({
    reducerPath: APP_ROLES_API_REDUCER_PATH,
    baseQuery: apiBaseQuery(),
    endpoints: builder => ({
        getAppRolesList: builder.query({
            query: ({ appId }) => {
                return {
                    url: `/iambff/v1/connected-apps/${appId}/app-roles`,
                    method: 'GET',
                };
            },
            transformResponse: response => {
                return response.roles;
            },
        }),
    }),
});

export const { useGetAppRolesListQuery } = appRolesApi;
